export class MyStudychoiceheartNotificationService {
    handleSuccess(): void {
        let notificationToShow: HTMLElement | null = null;
        notificationToShow = document.querySelector("[data-event-listener='.open-smc-201-notification']");
        this.toggleNotification(notificationToShow);
    }
    handleErrorStatusCodes(statusCode: number): boolean {
        let notificationToShow: HTMLElement | null = null;

        switch (statusCode) {
            case 400:
                notificationToShow = document.querySelector("[data-event-listener='.open-smc-400-notification']");
                break;
            case 500:
                notificationToShow = document.querySelector("[data-event-listener='.open-smc-500-notification']");
                break;
        }
        return this.toggleNotification(notificationToShow);
    }

    toggleNotification(notificationToShow: HTMLElement | null): boolean {
        if (notificationToShow && notificationToShow.classList.contains('hide')) {
            notificationToShow.classList.toggle("hide");
        }
        return false;
    }
}
